// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__OrKsf","col":"CardReaderDesc_col__-uOB4","label":"CardReaderDesc_label__1OGmB"};